import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Therapists from '../views/Therapists.vue'
import Admin from '../views/Admin.vue'
import TherapistForm from '../components/TherapistForm.vue'
import Login from '../views/Login.vue'
import UserProfile from '../views/UserProfile.vue'
import TherapistDetails from '../views/TherapistDetails.vue'
import AccountConfirmation from '../views/AccountConfirmation.vue'
import PasswordForgotten from '../views/PasswordForgotten.vue'
import PasswordReset from   '../views/PasswordReset.vue'
import store from '../store'

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/confirm-account/:id',
    name: 'ConfirmAccount',
    component: AccountConfirmation,
  },
  {
    path: '/terapeutas',
    name: 'Therapists',
    component: Therapists,
  },
  {
    path: '/terapeutas/:id',
    name: 'TherapistDetails',
    component: TherapistDetails,
  },
  {
    path: '/profile',
    name: 'Profile',
    component: UserProfile
  },
  {
    path: '/password-forgotten',
    name: 'PasswordForgotten',
    component: PasswordForgotten
  },
  {
    path: '/password-reset/:id',
    name: 'PasswordReset',
    component: PasswordReset
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: { requiresAuth: true },
  },
  {
    path: '/admin/terapeutas/:id?',
    name: 'TherapistEdit',
    component: TherapistForm,
    meta: { requiresAuth: true },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.state.isUserLoggedIn) {
      return next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
    
    return next();
  }

  if (to.path === '/login' && store.state.isUserLoggedIn) {
    console.log("redirecting");
    return next(from);
  }

  next();
});


// router.beforeEach((to, from, next) => {
//   // redirect to login page if not logged in and trying to access a restricted page
//   const publicPages = ['/login', '/register'];
//   const authRequired = !publicPages.includes(to.path);
//   const loggedIn = localStorage.getItem('user');

//   if (authRequired && !loggedIn) {
//     return next('/login');
//   }

//   next();
// })

export default router
